import apiClient from './client'

export interface ShareLink {
  id: string
  token: string
  item_id: string
  created_by: string
  expires_at: string
  max_views: number
  view_count: number
  created_at: string
}

export interface CreateShareLinkRequest {
  item_id: string
  expires_in: string // "1h", "24h", "7d", "30d", "90d"
  max_views: number // 0 = unlimited
}

export const shareLinksApi = {
  async create(req: CreateShareLinkRequest): Promise<ShareLink> {
    return apiClient.post<ShareLink>('/api/v1/share-links', req)
  },

  async list(): Promise<{ share_links: ShareLink[] }> {
    return apiClient.get<{ share_links: ShareLink[] }>('/api/v1/share-links')
  },

  async delete(id: string): Promise<void> {
    return apiClient.delete(`/api/v1/share-links/${id}`)
  },

  /**
   * Get a shared item by token (public, no auth required).
   * Uses raw fetch since apiClient sends credentials/auth headers.
   */
  async getSharedItem(token: string): Promise<any> {
    const baseURL = import.meta.env.VITE_API_URL || ''
    const response = await fetch(`${baseURL}/api/v1/shared/${token}`)
    if (!response.ok) {
      throw new Error('Share link is invalid or expired')
    }
    return response.json()
  },
}

export default shareLinksApi
